import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "xytool-module__calibrating"
}
const _hoisted_2 = {
  key: 3,
  class: "xymodule-module__select"
}

import {
  NInputNumber,
  NInputGroup,
  NInputGroupLabel,
  NForm,
  NFormItem,
  NAlert,
  NSpace,
} from 'naive-ui'
import { useThrottleFn } from '@vueuse/core'
import {
  BfButton,
  BfIcon,
  BfLoader,
  ButtonState,
  Colors,
} from '@finetic/bikefitting-ui'
import { deviceType } from '@/types/device'
import { PreviewImage } from '@/types/preview'
import { useI18n } from 'vue-i18n'
import { Icon } from '@iconify/vue'
import { useMessage } from 'naive-ui'
import BaseModule from './BaseModule.vue'

import { ref, computed, watch, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useMqttStore } from '@/store/mqttStore'
import { usePositionStore } from '@/store/positionStore'
import { useBikeStore } from '@/store/bikeStore'
import { useDeviceStore } from '@/store/deviceStore'
import { usePreferenceStore } from '@/store/preferenceStore'
import { getHoodsTerm } from '@/utils/utils'
import PairDevices from '@/components/controls/PairDevices.vue'

import {
  MqttMessage,
  MqttValue,
  xyToolDefinitions,
  xyToolHandlebarX,
  xyToolHandlebarY,
  xyToolSaddleX,
  xyToolSaddleY,
  xyToolBrakesX,
  xyToolBrakesY,
} from '@/mqttDefinitions'
import { BikeHoodsType } from '@/types/bike'


export default /*@__PURE__*/_defineComponent({
  __name: 'XYToolModule',
  setup(__props) {

const { t } = useI18n()
const message = useMessage()

const bikeStore = useBikeStore()
const positionStore = usePositionStore()
const deviceStore = useDeviceStore()
const preferenceStore = usePreferenceStore()

const mqttStore = useMqttStore()
const { doPublish } = mqttStore
const { getMessageOnTopic, client } = storeToRefs(mqttStore)

//Data init
const handlebarX = computed(() => getMessageOnTopic.value(xyToolHandlebarX))
const handlebarY = computed(() => getMessageOnTopic.value(xyToolHandlebarY))
const saddleX = computed(() => getMessageOnTopic.value(xyToolSaddleX))
const saddleY = computed(() => getMessageOnTopic.value(xyToolSaddleY))
const brakesX = computed(() => getMessageOnTopic.value(xyToolBrakesX))
const brakesY = computed(() => getMessageOnTopic.value(xyToolBrakesY))

watch(handlebarX, () => {
  handlebarXPosition.value = handlebarX.value
  isDirty.value.handlebarX = true
})
watch(handlebarY, () => {
  handlebarYPosition.value = handlebarY.value
  isDirty.value.handlebarY = true
})
watch(saddleX, () => {
  saddleXPosition.value = saddleX.value
  isDirty.value.saddleX = true
})
watch(saddleY, () => {
  saddleYPosition.value = saddleY.value
  isDirty.value.saddleY = true
})
watch(brakesX, () => {
  hoodsXPosition.value = brakesX.value
  isDirty.value.hoodsX = true
})
watch(brakesY, () => {
  hoodsYPosition.value = brakesY.value
  isDirty.value.hoodsY = true
})

const changeDevice = ref(false)
const editState = ref(false)

const { bikeData, bikeHoodsType, bikePreview } = storeToRefs(bikeStore)
const { hasPositioningMotors, hasXYTool } = storeToRefs(preferenceStore)
const {
  initialCalibrate,
  updatedCalibrate,
  noMotorsCalibrate,
  cancelCalibration,
} = positionStore
const { positionDeviation, isCalibrating, isCalibrated } =
  storeToRefs(positionStore)
const { xyToolStatus, motorStatus } = storeToRefs(deviceStore)

const hoodsXPosition = ref(0)
const hoodsYPosition = ref(0)

const handlebarXPosition = computed({
  get() {
    return positionDeviation.value.handlebarX
  },
  set(newValue) {
    positionDeviation.value.handlebarX = newValue
  },
})

const handlebarYPosition = computed({
  get() {
    return positionDeviation.value.handlebarY
  },
  set(newValue) {
    positionDeviation.value.handlebarY = newValue
  },
})

const saddleXPosition = computed({
  get() {
    return positionDeviation.value.saddleX
  },
  set(newValue) {
    positionDeviation.value.saddleX = newValue
  },
})

const saddleYPosition = computed({
  get() {
    return positionDeviation.value.saddleY
  },
  set(newValue) {
    positionDeviation.value.saddleY = newValue
  },
})

const isDirty = ref({
  handlebarX: false,
  handlebarY: false,
  saddleX: false,
  saddleY: false,
  hoodsX: false,
  hoodsY: false,
})

const allFieldsDirty = computed(() => {
  return Object.values(isDirty.value).every((value) => value)
})

const setEditState = (value: boolean) => {
  editState.value = value
  if (!value) {
    resetDirtyState()
  }
}

const setFocusHoods = () => {
  switch (bikeHoodsType.value) {
    case BikeHoodsType.DROPBAR:
      bikePreview.value = PreviewImage.DROPBAR_HOODS
      break

    case BikeHoodsType.FLATBAR:
      bikePreview.value = PreviewImage.FLATBAR_GRIPS
      break

    case BikeHoodsType.TRIBAR:
      bikePreview.value = PreviewImage.TRIBAR_PADS
      break

    default:
      bikePreview.value = PreviewImage.DROPBAR_HOODS
      break
  }
}

const setFocusHandlebar = () => {
  switch (bikeHoodsType.value) {
    case BikeHoodsType.DROPBAR:
      bikePreview.value = PreviewImage.DROPBAR_HANDLEBAR
      break

    case BikeHoodsType.FLATBAR:
      bikePreview.value = PreviewImage.FLATBAR_HANDLEBAR
      break

    case BikeHoodsType.TRIBAR:
      bikePreview.value = PreviewImage.TRIBAR_HANDLEBAR
      break

    default:
      bikePreview.value = PreviewImage.DROPBAR_HANDLEBAR
      break
  }
}

const setFocusSaddle = () => {
  bikePreview.value = PreviewImage.SADDLE
}

const setDefault = () => {
  switch (bikeHoodsType.value) {
    case BikeHoodsType.DROPBAR:
      bikePreview.value = PreviewImage.DROPBAR_BIKE
      break

    case BikeHoodsType.FLATBAR:
      bikePreview.value = PreviewImage.FLATBAR_BIKE
      break

    case BikeHoodsType.TRIBAR:
      bikePreview.value = PreviewImage.TRIBAR_BIKE
      break

    default:
      bikePreview.value = PreviewImage.DROPBAR_BIKE
      break
  }
}

const confirm = async () => {
  const success = hasPositioningMotors.value
    ? !isCalibrated.value
      ? await initialCalibrate()
      : await updatedCalibrate()
    : await noMotorsCalibrate()

  if (success) {
    editState.value = false
    resetDirtyState()
  } else {
    message.error(t('setup.calibrate.outOfReach'))
  }
}

const cancel = () => {
  editState.value = false
  cancelCalibration()
}

const sendToXyTool = () => {
  let index = 0

  const xyData: Array<{ mqtt: MqttValue; position: any }> = [
    { mqtt: xyToolHandlebarX, position: handlebarXPosition },
    { mqtt: xyToolHandlebarY, position: handlebarYPosition },
    { mqtt: xyToolSaddleX, position: saddleXPosition },
    { mqtt: xyToolSaddleY, position: saddleYPosition },
    { mqtt: xyToolBrakesX, position: hoodsXPosition },
    { mqtt: xyToolBrakesY, position: hoodsYPosition },
  ]

  const throttledDoPublish = useThrottleFn(
    (item: { mqtt: MqttValue; position: any }) => {
      doPublish(
        {
          topic: item.mqtt.topic,
          payload: item.position.value,
        } as MqttMessage,
        item.mqtt,
        client.value,
      )
    },
    200,
  )

  const processNext = () => {
    if (index < xyData.length) {
      throttledDoPublish(xyData[index])
      index++
      setTimeout(processNext, 200)
    }
  }

  processNext()
}

const resetValues = async () => {
  if (!hasPositioningMotors.value && bikeData?.value) {
    positionDeviation.value.handlebarX = bikeData.value.SF_HANDLEBAR_CENTER_X
    positionDeviation.value.handlebarY = bikeData.value.SF_HANDLEBAR_CENTER_Y
    positionDeviation.value.saddleX = bikeData.value.SF_SADDLE_CENTER_X
    positionDeviation.value.saddleY = bikeData.value.SF_SADDLE_CENTER_Y
    await confirm()
  }
}

const resetDirtyState = () => {
  isDirty.value = {
    handlebarX: false,
    handlebarY: false,
    saddleX: false,
    saddleY: false,
    hoodsX: false,
    hoodsY: false,
  }
}

const motorError = computed(() => {
  return (
    motorStatus.value.overcurrent ||
    motorStatus.value.stalled ||
    motorStatus.value.highTemperature
  )
})

onMounted(() => {
  resetValues()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModule, {
    definition: _unref(xyToolDefinitions),
    connected: _unref(xyToolStatus).connected,
    connecting: _unref(xyToolStatus).connecting,
    error: _unref(motorStatus).highTemperature || _unref(motorStatus).hasHadHighTemperature
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_unref(t)('modules.xyTool.index')), 1)
    ]),
    config: _withCtx(() => [
      _createElementVNode("div", {
        class: "xytool-module__settings",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (changeDevice.value = true))
      }, [
        _createVNode(_unref(BfIcon), {
          icon: "/icons/01-Interface Essential/12-Settings/cog.svg",
          color: _unref(Colors).Light
        }, null, 8, ["color"])
      ])
    ]),
    middle: _withCtx(() => [
      (!_unref(isCalibrating))
        ? (_openBlock(), _createBlock(_unref(NForm), {
            key: 0,
            ref: "formRef",
            "label-placement": "left"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NFormItem), {
                label: _unref(t)('common.bike.saddle')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), null, {
                        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                          _createTextVNode("X", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(NInputNumber), {
                        status: editState.value && !isDirty.value.saddleX ? 'warning' : undefined,
                        value: saddleXPosition.value,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((saddleXPosition).value = $event)),
                        "show-button": false,
                        onFocus: _cache[2] || (_cache[2] = ($event: any) => ((setFocusSaddle(), (isDirty.value.saddleX = true)))),
                        onBlur: _cache[3] || (_cache[3] = ($event: any) => (setDefault()))
                      }, null, 8, ["status", "value"]),
                      _createVNode(_unref(NInputGroupLabel), null, {
                        default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                          _createTextVNode("Y", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(NInputNumber), {
                        status: editState.value && !isDirty.value.saddleY ? 'warning' : undefined,
                        value: saddleYPosition.value,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((saddleYPosition).value = $event)),
                        "show-button": false,
                        onFocus: _cache[5] || (_cache[5] = ($event: any) => ((setFocusSaddle(), (isDirty.value.saddleY = true)))),
                        onBlur: _cache[6] || (_cache[6] = ($event: any) => (setDefault()))
                      }, null, 8, ["status", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItem), {
                label: _unref(t)('common.bike.handlebar')
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), null, {
                        default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                          _createTextVNode("X", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(NInputNumber), {
                        status: editState.value && !isDirty.value.handlebarX ? 'warning' : undefined,
                        value: handlebarXPosition.value,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((handlebarXPosition).value = $event)),
                        "show-button": false,
                        onFocus: _cache[8] || (_cache[8] = ($event: any) => ((setFocusHandlebar(), (isDirty.value.handlebarX = true)))),
                        onBlur: _cache[9] || (_cache[9] = ($event: any) => (setDefault()))
                      }, null, 8, ["status", "value"]),
                      _createVNode(_unref(NInputGroupLabel), null, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createTextVNode("Y", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(NInputNumber), {
                        status: editState.value && !isDirty.value.handlebarY ? 'warning' : undefined,
                        value: handlebarYPosition.value,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((handlebarYPosition).value = $event)),
                        "show-button": false,
                        onFocus: _cache[11] || (_cache[11] = ($event: any) => ((setFocusHandlebar(), (isDirty.value.handlebarY = true)))),
                        onBlur: _cache[12] || (_cache[12] = ($event: any) => (setDefault()))
                      }, null, 8, ["status", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NFormItem), {
                label: _unref(getHoodsTerm)(_unref(bikeHoodsType))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NInputGroup), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(NInputGroupLabel), null, {
                        default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                          _createTextVNode("X", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(NInputNumber), {
                        status: editState.value && !isDirty.value.hoodsX ? 'warning' : undefined,
                        value: hoodsXPosition.value,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((hoodsXPosition).value = $event)),
                        "show-button": false,
                        onFocus: _cache[14] || (_cache[14] = ($event: any) => ((setFocusHoods(), (isDirty.value.hoodsX = true)))),
                        onBlur: _cache[15] || (_cache[15] = ($event: any) => (setDefault()))
                      }, null, 8, ["status", "value"]),
                      _createVNode(_unref(NInputGroupLabel), null, {
                        default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                          _createTextVNode("Y", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_unref(NInputNumber), {
                        status: editState.value && !isDirty.value.hoodsY ? 'warning' : undefined,
                        value: hoodsYPosition.value,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((hoodsYPosition).value = $event)),
                        "show-button": false,
                        onFocus: _cache[17] || (_cache[17] = ($event: any) => ((setFocusHoods(), (isDirty.value.hoodsY = true)))),
                        onBlur: _cache[18] || (_cache[18] = ($event: any) => (setDefault()))
                      }, null, 8, ["status", "value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(NSpace), { justify: "end" }, {
                default: _withCtx(() => [
                  (_unref(hasXYTool) && (!editState.value || !_unref(hasPositioningMotors)))
                    ? (_openBlock(), _createBlock(_unref(BfButton), {
                        key: 0,
                        state: 
              _unref(xyToolStatus).connected
                ? _unref(ButtonState).Enabled
                : _unref(ButtonState).Disabled
            ,
                        onClick: sendToXyTool
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('modules.xyTool.showOnXy')), 1)
                        ]),
                        _: 1
                      }, 8, ["state"]))
                    : _createCommentVNode("", true),
                  (!editState.value && _unref(hasPositioningMotors))
                    ? (_openBlock(), _createBlock(_unref(BfButton), {
                        key: 1,
                        onClick: _cache[19] || (_cache[19] = ($event: any) => ((setEditState(true), resetDirtyState())))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('common.calibrate')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (editState.value && _unref(hasPositioningMotors))
                    ? (_openBlock(), _createBlock(_unref(BfButton), {
                        key: 2,
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (setEditState(false)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (editState.value || !_unref(hasPositioningMotors))
                    ? (_openBlock(), _createBlock(_unref(BfButton), {
                        key: 3,
                        onClick: confirm,
                        state: 
              allFieldsDirty.value || !_unref(hasPositioningMotors)
                ? _unref(ButtonState).Enabled
                : _unref(ButtonState).Disabled
            
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(!_unref(hasPositioningMotors) ? _unref(t)('common.measure') : _unref(t)('common.confirm')), 1)
                        ]),
                        _: 1
                      }, 8, ["state"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true),
      (_unref(isCalibrating) && !motorError.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_unref(BfLoader)),
            _createElementVNode("p", null, _toDisplayString(_unref(t)('modules.xyTool.isCalibrating')), 1),
            _createVNode(_unref(BfButton), { onClick: cancel }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('common.cancel')), 1)
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true),
      (_unref(isCalibrating) && motorError.value)
        ? (_openBlock(), _createBlock(_unref(NAlert), {
            key: 2,
            title: _unref(t)('modules.xyTool.motorError.index'),
            bordered: false
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(Icon), {
                icon: "mdi:information-outline",
                style: { fontSize: '24px' }
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('modules.xyTool.motorError.content')), 1)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true),
      (changeDevice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(PairDevices, {
              type: _unref(deviceType).xyTool,
              onClose: _cache[21] || (_cache[21] = ($event: any) => (changeDevice.value = false))
            }, null, 8, ["type"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["definition", "connected", "connecting", "error"]))
}
}

})